import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";

const Login = () => {

  const [loading, setLoading] = useState(false); // New state for loading

  const handleLogin = () => {
    // setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL
    window.location.href = apiUrl + "/auth/microsoft_graph_auth";
  };


  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Please log in to access the application.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLogin} disabled={loading} loading={loading}>
        Login
      </Button>
    </Box>
  );
};

export default Login;
